/**
 * 🔢 Parse une valeur décimale en acceptant la virgule OU le point comme séparateur.
 *
 * Le format unique stocké en BDD est toujours le point (norme JSON/Pydantic),
 * mais l'utilisateur peut saisir "1,50" ou "1.50" indifféremment.
 *
 * @param {string|number|null|undefined} v - Valeur à parser
 * @returns {number|null} Nombre normalisé OU null si invalide / vide
 */
export const parseDecimal = (v) => {
  if (v === null || v === undefined || v === '') return null;
  // Normaliser : remplacer la virgule par un point + retirer les espaces (séparateurs de milliers FR)
  const normalized = String(v).replace(/\s/g, '').replace(',', '.').trim();
  if (normalized === '' || normalized === '-' || normalized === '.') return null;
  const n = parseFloat(normalized);
  return Number.isFinite(n) ? n : null;
};

/**
 * Variante avec valeur par défaut (utile pour stock_actuel etc. où null n'est pas désiré).
 */
export const parseDecimalOr = (v, fallback = 0) => {
  const n = parseDecimal(v);
  return n === null ? fallback : n;
};

/**
 * Attributs HTML conseillés pour un input décimal acceptant virgule et point.
 * Utilisation : <input type="text" {...decimalInputProps} ... />
 */
export const decimalInputProps = {
  type: 'text',
  inputMode: 'decimal',
  // Autorise chiffres, virgule, point, signe moins (les espaces sont strippés à la saisie via onInput)
  pattern: '^-?\\d+([.,]\\d+)?$',
  autoComplete: 'off',
};
